import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { t } from "i18next";
import { useParams } from "react-router-dom";
import { Pagination } from "ui";

import { BoxesTable } from "../../components";
import { useProductBoxesList } from "../../hooks";

import styles from "./AvailableInBoxes.module.scss";

export interface SellableSummary {
  sellable: number;
  pickupAvailable: number;
  reserved: number;
  warehouse: number;
}

interface AvailableInBoxesProps {
  summary?: SellableSummary;
}

const AvailableInBoxes = ({ summary }: AvailableInBoxesProps) => {
  const { productVariantId } = useParams();

  const {
    boxesItemsList,
    isLoading,
    page,
    totalItems,
    sorting,
    setSorting,
    setPage
  } = useProductBoxesList(productVariantId);

  return (
    <div className={styles.availableInBoxes}>
      {summary ? (
        <div className={styles.availableInBoxes_summary}>
          <span className={styles.availableInBoxes_summary_headline}>
            {`${t("Sellable now")}: ${summary.sellable}`}
          </span>
          <span className={styles.availableInBoxes_summary_breakdown}>
            {`${summary.pickupAvailable} ${t("picking")} − ${summary.reserved} ${t(
              "reserved"
            )} · ${summary.warehouse} ${t("warehouse")}`}
          </span>
        </div>
      ) : null}
      <div className={styles.availableInBoxes_tableContainer}>
        <BoxesTable
          boxes={boxesItemsList ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
        />
      </div>
      <Pagination
        currentPage={page}
        onChange={setPage}
        perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
        totalItems={totalItems}
      />
    </div>
  );
};

export default AvailableInBoxes;
